export const CONSTRAINT_FLAGS = [
  {
    type: "no_variants",
    explanation: "Zero observed synonymous, missense, pLoF variants",
  },
  { type: "no_exp_syn", explanation: "Zero expected synonymous variants" },
  { type: "no_exp_mis", explanation: "Zero expected missense variants" },
  { type: "no_exp_lof", explanation: "Zero expected pLoF variants" },
  {
    type: "syn_outlier",
    explanation:
      "Too many or too few synonymous variants; synonymous z score < -5 synonymous z score > 5",
  },
  {
    type: "mis_too_many",
    explanation: "Too many missense variants; missense z score < -5",
  },
  {
    type: "lof_too_many",
    explanation: "Too many pLoF variants; pLoF z score < -5",
  },
];

export const CONSTRAINT_FLAGS_DICT = CONSTRAINT_FLAGS.reduce(
  (a, i) => ({ ...a, ...{ [i.type]: [i.explanation] } }),
  {}
);

export const VARIANTS_TYPES = [
  { name: "Missense", suffix: "mis" },
  { name: "Synonymous", suffix: "syn" },
  { name: "Loss of Function", suffix: "lof" },
];

export const DBNSFP_COLORS = {
  Low: "#00cc00",
  Medium: "#ff8000",
  High: "#e60000",
};

export const DBNSFP_GO_KEYS = {
  molecular_function: "Molecular Function",
  biological_process: "Biological Process",
  cellular_component: "Cellular Component",
};

export const DBNSFP_GENE_DAMAGE_KEYS = {
  primary_immunodeficiency: "Primary Immunodeficiency",
  mendelian: "Mendelian",
  cancer: "Cancer",
};

export const DBNSFP_TABLE_FIELDS = {
  recessive: ["p_rec", "known_recessive_info"],
  intolerance: ["rvis_evs", "rvis_evs_percentile", "loftool_score"],
  haploinsufficiency: ["p_hi", "hipred_score", "ghis", "hipred"],
  essentials: [
    "essential_gene",
    "essential_crispr",
    "essential_crispr2",
    "essential_mutagenesis",
  ],
  indispensability: ["indispensability_score", "indispensability_pred"],
};

export const DBNSFP_TABLE_FIELDS_LABELS = {
  p_rec: "P(rec)",
  known_recessive_info: "Known recessive status",
  rvis_evs: "RVIS EVS",
  rvis_evs_percentile: "RVIS EVS percentage",
  loftool_score: "LoFtool Score",
  p_hi: "P(HI)",
  hipred_score: "HIPred score",
  ghis: "GHIS",
  hipred: "HIPred",
  essential_gene: "Essential gene",
  essential_crispr: "Essential gene CRISPR",
  essential_crispr2: "Essential gene CRISPR2",
  essential_mutagenesis: "Essential mutagenesis",
  indispensability_score: "Indispensability score",
  indispensability_pred: "Indispensability prediction",
};

export const DBNSFP_PATHWAYS = {
  BioCarta: "pathway_biocarta",
  Consensus: "pathway_consensuspathdb",
  UniProt: "pathway_uniprot",
};

export const DBNSFP_EXPRESSIONS = {
  "GNF/Atlas expression data": "expression_gnf_atlas",
  "Egenetics expression data": "expression_egenetics",
};
